import { FunctionComponent, useEffect, useMemo } from 'react';

import { ObservationType } from '@intoto-dev/utils-observation-helpers/lib/types';

import useFetch from '../../hooks/useFetch';
import useParams from '../../hooks/useParams';

import ObservationContainer from './ObservationContainer';

interface LocationContainerProps {
  location: string;
  specificity?: string;
  offset?: number;
}

interface StationData {
  entity: {
    id: string;
    name: string;
    location: string;
    series: {
      id: string;
      type: ObservationType;
    }[];
  }
}

const LocationContainer: FunctionComponent<LocationContainerProps> = ({
  location,
  specificity,
  offset,
}) => {
  const params = useParams();
  const { isLoading, error, data } = useFetch<StationData>(`station/${location}`);

  const days = useMemo(() => {
    const defaultDays = 14;
    const paramDays = params.get('days');

    if (!paramDays) {
      return defaultDays;
    }

    try {
      return parseInt(paramDays, 10);
    } catch (e) {
      return defaultDays;
    }
  }, [params]);

  useEffect(() => {
    if (!error && data) {
      document.title = `${data.entity.name}, ${data.entity.location}`;
    }
  }, [data, error]);

  if (isLoading) {
    return (
      <div className="centered">
        Loading location...
      </div>
    );
  }

  if (error) {
    return (
      <div className="centered">
        <h2>Whoops, something went wrong</h2>
        {error.message}
      </div>
    );
  }

  if (!data) {
    return <div className="centered">Unknown error.</div>;
  }

  return (
    <ObservationContainer
      observation={data.entity.series[0]}
      days={days}
      specificity={specificity}
      offset={offset}
    />
  );
};

export default LocationContainer;
